import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { getStore } from '@core/store';
import { serializer } from './serializer';

bus.on(constants.EVENTS.NOTIFICATION.LIST_ALL.REFRESH, () => {
  const requestId = 'listAllNotifications-' + Date.now();
  bus.emit(constants.EVENTS.NOTIFICATION.LIST_ALL.REFRESHING);
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: constants.ENDPOINTS.NOTIFICATION.GET_LIST,
    method: 'GET',
    data: {}
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      const parsed = serializer.deserialize(res);
      if (parsed.success) {
        bus.emit(constants.EVENTS.NOTIFICATION.LIST_ALL.REFRESHED, parsed.data);
      } else {
        bus.emit(constants.EVENTS.NOTIFICATION.LIST_ALL.REFRESH_ERROR, parsed);
      }
    }
  });
});

bus.on(constants.EVENTS.NOTIFICATION.UPDATE, saveNotification);
bus.on(constants.EVENTS.NOTIFICATION.SUBMIT, saveNotification);
bus.on(constants.EVENTS.NOTIFICATION.DELETE, (data) =>
  saveNotification({ ...data, action: 'delete' })
);

async function saveNotification(data) {
  const requestId = 'saveNotification-' + Date.now();
  const store = getStore('notification');
  const oldNotifications = store?.state?.list_all?.list || [];

  bus.emit(constants.EVENTS.LOADING.START);
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: constants.ENDPOINTS.NOTIFICATION.UPDATE,
    method: 'POST',
    data: serializer.serialize(data, oldNotifications)
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      const parsed = serializer.deserialize(res);
      bus.emit(constants.EVENTS.LOADING.FINISH);
      if (parsed.success) {
        bus.emit(constants.EVENTS.NOTIFICATION.UPDATED, parsed.data);
        bus.emit(constants.EVENTS.NOTIFICATION.LIST_ALL.REFRESH);
      } else {
        bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
          title: 'Echec de sauvegarde',
          body: parsed.message
        });
        bus.emit(constants.EVENTS.NOTIFICATION.UPDATED, parsed);
      }
    }
  });
}
